export interface PatientSelfOnboardParams {
  patientId: string
  caseId: string
  treatmentId: string
}

const PatientSelfOnboardUrls = {
  base: {
    match: '/patient-self-onboarding',
  },
  hasPatient: {
    match: '/patient-self-onboarding/:patientId',
  },
  existingPatient: {
    match: '/patient-self-onboarding/existing-patient',
  },
  newPatient: {
    match: '/patient-self-onboarding/new-patient',
    create: () => `/patient-self-onboarding/new-patient`,
  },
  existingPatientDetails: {
    match: '/patient-self-onboarding/:patientId/details',
    create(patientId: string) {
      return `/patient-self-onboarding/${patientId}/details`
    },
  },
  addCase: {
    match: '/patient-self-onboarding/:patientId/pcase',
    create(patientId: string) {
      return `/patient-self-onboarding/${patientId}/pcase`
    },
  },
  addDiagnoses: {
    match: '/patient-self-onboarding/:patientId/case/:caseId/diagnosis',
    create: (patientId: string, caseId: string) =>
      `/patient-self-onboarding/${patientId}/case/${caseId}/diagnosis`,
  },
  addTreatment: {
    match: '/patient-self-onboarding/:patientId/case/:caseId/treatment',
    create: (patientId: string, caseId: string) =>
      `/patient-self-onboarding/${patientId}/case/${caseId}/treatment`,
  },
  addSession: {
    match:
      '/patient-self-onboarding/:patientId/case/:caseId/treatment/:treatmentId/session',
    create: (patientId: string, caseId: string, treatmentId: string) =>
      `/patient-self-onboarding/${patientId}/case/${caseId}/treatment/${treatmentId}/session`,
  },
  survey: {
    match: '/patient-self-onboarding/:patientId/case/:caseId/survey',
    create: (patientId: string, caseId: string) =>
      `/patient-self-onboarding/${patientId}/case/${caseId}/survey`,
  },
  surveyCompletion: {
    match: '/patient-self-onboarding/:patientId/case/:caseId/survey-completion',
    create: (patientId: string, caseId: string) =>
      `/patient-self-onboarding/${patientId}/case/${caseId}/survey-completion`,
  },
}

export default PatientSelfOnboardUrls
